import {SiteTargetType} from "@/enums/type";
import {DebtEmployeeStatus} from "@/enums/status";

export class ReceiptEmployeeParams {
    page = 1;
    limit = 10;
    targetRowGuid?: string;
    targetType = SiteTargetType.Employee;
    status = DebtEmployeeStatus.NotYetCollect;
    revenueExpenditureId?: number;
}
